import { configureStore } from '@reduxjs/toolkit';
import dashboardReducer from './dashboardSlice.js';
import datasourceReducer from './datasourceSlice.js';
import projectFilterReducer from './projectFilterSlice.js';

export const dashboardStore = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    datasources: datasourceReducer,
    projectFilter: projectFilterReducer,
  },
});

export default dashboardStore;
